import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { CustomerPayload } from "./customerTypes"

export type CreateCustomerRequest = CustomerPayload

export const createCustomer = async (
  params: CreateCustomerRequest
) => {
  await api.post("/beepaidgo/customers/", {
    body: {
      ...params,
      email: params.email || null,
      phone: params.phone || null,
    },
  })

  queryClient.invalidateQueries([CUSTOMERS_QUERY_KEY])
}
